import React, { Fragment } from "react";
import Navbar2 from "../../components/Navbar2";
import Services2 from "../../components/Services2";
import Pricing from "../../components/Pricing";
import FunFact from "../../components/FunFact";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import Hero from "../../components/hero";
import AboutAloca from "../../components/AboutAloca";
import ProjectSingleAloca from "../../components/ProjectSingleAloca";

const AboutPage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <Hero />
      <ProjectSingleAloca />
      <AboutAloca />
      <Services2 srvClass={"wpo-service-section-s3"} />
      <Pricing />
      <FunFact fnClass={"section-padding"} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutPage;
